<template>
	<transition name="slide-vertical">
		<div class="package_activity_card">
			<hgroup class="flex heading_collapse">
				<figure
					v-if="activity.PhotoVersion"
					:style="'background-image: url(' + photo + ')'"
				/>
				<div>
					<span class="steps"
						>{{ activity_index + 1 }} OF {{ activities_count }}</span
					>
					<partner-experience-tag
						v-if="activity.Owner_ClientLocationKey"
						style="margin-left:10px;margin-bottom:6px;"
					/>
					<h3>{{ activity.Name }}</h3>
					<small>
						<span class="text-blue" v-if="activity.AppointmentDate">{{
							activity.AppointmentDate | moment('dddd, MMMM Do YYYY')
						}}</span>
						<span v-else>No date selected</span>
						•
						<span
							v-if="selectedTimeString"
							style="white-space: nowrap;"
							class="text-blue"
							>{{ selectedTimeString }}</span
						>
						<span v-else>No time selected</span>
					</small>
				</div>
			</hgroup>

			<private-ui
				:privateTourRateName="activity.PrivateTourRateName"
				:privateTourRateDescription="activity.PrivateTourRateDescription"
				:privateToursOnly="activity.PrivateToursOnly"
				v-if="activity.EnablePrivateTours && !activity.PrivateToursOnly"
				v-model="activity.IsPrivateTour"
				@privateSelection="handlePrivateSelection($event)"
				ref="privateUi"
			></private-ui>

			<package-guest-ui
				:entityHierarchyKey="activity.EntityHierarchyKey"
				:enableRateDuration="
					activity.CapacityTypeKey == 2 || activity.CapacityTypeKey == 3
				"
				:totalGuestInPackage="totalGuestInPackage"
				:totalGuestInActivity="totalGuestInActivity"
				:isPackage="isPackage"
				:isPrivateTour="activity.IsPrivateTour"
				:disabled="disableGuestUi"
			/>
			<date-ui
				:disabled="disableDateUi"
				:activityDate="activity.AppointmentDate"
				:entityHierarchyKey="activity.EntityHierarchyKey"
				:peeps="totalGuestInActivity"
			/>

			<pre>getTimesLoading: {{ getTimesLoading }}</pre>
			<pre>hideUnselectedTimes: {{ hideUnselectedTimes }}</pre>

			<loader v-if="getTimesLoading" />

			<div v-else>
				<large-group-times-ui
					v-if="
						(activity.CapacityTypeKey == 2 || activity.CapacityTypeKey == 3) &&
							activity.Times
					"
					:totalGuestInActivity="totalGuestInActivity"
					:hideUnselectedTimes="hideUnselectedTimes"
					:activity="activity"
					@showUnselectedTimes="showUnselectedTimes"
					:entityHierarchyKey="activity.EntityHierarchyKey"
				/>

				<times-ui
					:activity="activity"
					:totalGuestInActivity="totalGuestInActivity"
					v-if="
						activity.CapacityTypeKey != 3 &&
							activity.CapacityTypeKey != 2 &&
							activity.Times
					"
					:isPackage="true"
					:radioName="'activity-times-' + activity_index"
					:addToCartLoading="addToCartLoading"
					:showAllTimes="true"
					:hideUnselectedTimes="hideUnselectedTimes"
					@showUnselectedTimes="showUnselectedTimes"
					:entityHierarchyKey="activity.EntityHierarchyKey"
				/>
			</div>
			<div v-if="noTimesError.show">
				<p class="mt-0 bg-gray p-2 border_radius flex_start">
					<i class="material-icons mr-1">event_busy</i>
					<span v-if="noTimesError.notes === ''">
						There are no available times for this date.
						<strong>Try another date.</strong>
					</span>
					<span v-else v-html="noTimesError.notes" />
				</p>
			</div>
		</div>
	</transition>
</template>

<script>
	import Loader from './Loader.vue';
	import PackageGuestUi from './GuestUi.vue';
	import DateUi from './DateUi.vue';
	import PrivateUi from './PrivateUi.vue';

	import { mapActions, mapGetters, mapState } from 'vuex';

	import TimesUi from './TimesUi.vue';
	import LargeGroupTimesUi from './LargeGroupTimesUi.vue';

	import watchActivityTimes from '../mixins/watchActivityTimes.js';
	import PartnerExperienceTag from '@/components/PartnerExperienceTag';

	export default {
		name: 'PackageActivityCard',
		mixins: [watchActivityTimes],
		props: [
			'activity',
			'activity_index',
			'activities_count',
			'totalGuestInPackage',
			'isPackage',
			'addToCartLoading',
			'privatePkg',
			//"activeProductDetails"
		],
		activated() {
			console.log(
				`${this.activity.Name} packageActivityCard activated()`,
				this.activity,
				this.activity.IsPrivateTour
			);
		},
		data: function() {
			return {
				showPEModal: false,
				noTimesError: {
					show: false,
					notes: '',
				},
				hideUnselectedTimes: false,
				hasMadePrivateSelection: false,
				previousPrivateTourState: false,
				//activityMonthData: []
			};
		},

		computed: {
			...mapGetters(['activeProductDetails']),
			...mapState(['getTimesLoading']),

			modify() {
				return this.$route.params.modify === 'modify';
			},
			disableDateUi() {
				if (this.activity.CapacityTypeKey == 1 && !this.totalGuestInActivity)
					return true;
				else return false;
			},
			disableGuestUi() {
				if (
					this.activity.EnablePrivateTours &&
					!this.activity.PrivateToursOnly
				) {
					return !this.hasMadePrivateSelection;
				}
				return false;
			},

			selectedTimeString() {
				//return false;
				if (this.activity.SelectedTimes) {
					return this.activity.SelectedTimes.length
						? this.activity.SelectedTimes[0].DisplayName
						: false;
				}
				return false;
			},

			getTimesParams() {
				return {
					ClientLocationKey: this.$route.params.client,
					EntityHierarchyKey: this.activity.EntityHierarchyKey,
					Rates: this.activity.Rates,
					Date: this.$moment(this.activity.AppointmentDate).format(
						'YYYY-MM-DD'
					),
					OrderKey: this.$store.state.order.OrderKey
						? this.$store.state.order.OrderKey
						: null,
					OrderEntityKey: this.activity.OrderEntityKey
						? this.activity.OrderEntityKey
						: null,
					OrderEntityTimeKey: '',
					HotelLatitude: '',
					HotelLongitude: '',
					IsLargeGroup: false,
					PackageKey: this.isPackage,
					CapacityTypeKey: this.activity.CapacityTypeKey,
					AddOns: this.activity.AddOns,
					PhotoPackageAddOns: this.activity.PhotoPackageAddOns,
					PreviousPrivateTourState: this.previousPrivateTourState,
					IsPrivateTour: this.activity.IsPrivateTour,

					Activity: this.activity,
				};
			}, // getTimesParams

			totalGuestInActivity() {
				let c = 0;

				if (this.activity.Rates) {
					this.activity.Rates.forEach((rate) => {
						if (!rate.IsPrivateTourRate) {
							c = c + rate.Participants;
						}
					});
				}
				return c;
			}, // totalGuestInActivity

			photo() {
				return (
					this.activity.PhotoDomain +
					'w_140,h_140,c_fill' +
					'/v' +
					this.activity.PhotoVersion +
					this.activity.PhotoFolder +
					'/original'
				);
			}, // photo
		},

		components: {
			PackageGuestUi,
			DateUi,
			TimesUi,
			LargeGroupTimesUi,
			Loader,
			PrivateUi,
			PartnerExperienceTag,
		},

		watch: {
			'activity.Rates': {
				handler(newVal, oldVal) {
					console.log(`${this.activity.Name} rate change detected`);
					this.handleGetTimesParamsChanges();
				},
				deep: true,
			},
			getTimesLoading: {
				handler(newVal) {
					this.$set(this.activity, 'getTimesLoading', newVal);
				},
			},
			// totalGuestInActivity: {
			//   handler(newVal, oldVal) {
			//     //console.log("watch totalGuestInActivity");

			//     if (
			//       newVal > 0 &&
			//       oldVal !== newVal &&
			//       this.activeProductDetails &&
			//       !this.activeProductDetails.IsLargeGroup
			//     ) {
			//       console.log("watch totalGuestInActivity");
			//       this.handleGetTimesParamsChanges();
			//     }
			//     //}
			//   },
			//   //deep: true
			//   immediate: true,
			// },

			// If the Date changes, get new times from gettimes
			'getTimesParams.Date': {
				handler(newVal, oldVal) {
					// console.log("watch getTimesParams.Date " + typeof oldVal + " - " + typeof newVal);

					if (oldVal != newVal && typeof newVal == 'string') {
						// console.log("watch getTimesParams.Date");
						this.handleGetTimesParamsChanges();
					}
				},
				//deep: true
				immediate: true,
			},

			'activity.IsPrivateTour': {
				handler(newVal, oldVal) {
					if (typeof newVal == 'boolean') {
						this.previousPrivateTourState = oldVal;
					}
					if (typeof newVal == 'boolean') {
						this.handleGetTimesParamsChanges();
					}
				},
			},
		},

		methods: {
			...mapActions([
				'ajaxGetTimes',
				//  "ajaxGetMonthAvailability"
			]),
			handlePrivateSelection(status) {
				this.activity.IsPrivateTour = status;
				this.hasMadePrivateSelection = true;
			},

			showUnselectedTimes() {
				//alert('showUnselectedTimes');
				setTimeout(() => {
					this.hideUnselectedTimes = false;
				}, 50);

				// if this is a simple time, reset Times which resets SelectedTimes

				const findSelected = this.activity.Times.filter((ele) => {
					return ele.IsSelected === true;
				});
				// activeProductDetails:Object
				if (
					findSelected &&
					this.activeProductDetails &&
					!this.activeProductDetails.IsLargeGroup &&
					this.activity.CapacityTypeKey != 2 &&
					this.activity.CapacityTypeKey != 3
				) {
					// console.log("resetting IsSelected, AddOns, PickupLocation, and PickupLocations");

					findSelected.forEach((time) => {
						time.IsSelected = false;
						if (time.AddOns) {
							time.AddOns.forEach((addon) => {
								addon.Quantity = 0;
							});
						}
						if (time.PickupLocation) {
							time.PickupLocation = null;
						}
						if (time.PickupLocations) {
							time.PickupLocations.forEach((location) => {
								location.IsSelected = false;
							});
						}
					});
				}
			},

			handleGetTimesParamsChanges() {
				if (
					(this.activity.IsPrivateTour ||
						this.activeProductDetails.Participants ==
							this.totalGuestInActivity ||
						this.activity.CapacityTypeKey == 2 ||
						this.activity.CapacityTypeKey == 3) &&
					this.getTimesParams.Date &&
					!this.getTimesParams.Date.includes('Invalid')
				) {
					this.noTimesError.show = false;
					this.noTimesError.notes = '';

					this.ajaxGetTimes({
						...this.getTimesParams,
						callback: (json) => {
							// console.log("callback ajaxGetTimes json", json);

							if (typeof window.OnDateSelected != 'undefined') {
								// console.log("window.OnDateSelected()");
								window.OnDateSelected(
									this.$store.getters.simpleOrder,
									this.activity,
									this.activeProductDetails
								);
							}

							if (json && json.Times) {
								// console.log(json.Times);
								// [...activity.AddOns]; // deep copy
								json.Times.forEach((time) => {
									// if this time exist in the activity.clearedTimes array
									// mark them as IsSelected = false;
									if (
										this.activity &&
										this.activity.clearedTimes &&
										this.modify
									) {
										let findMeInClearedTime = this.activity.clearedTimes.find(
											(ele) => {
												return ele.Value == time.Value;
											}
										);
										if (findMeInClearedTime) {
											//alert("findMeInClearedTime: " + findMeInClearedTime.Value);
											time.IsSelected = false;
										}
									}

									// if the time alread has Addons, fon't overwrite them
									// if (time.AddOns.length == 0) {
									//   //alert("copy addons from activity...");
									//   let activityAddOns = JSON.parse(
									//     JSON.stringify(this.activity.AddOns)
									//   );
									//   time.AddOns = activityAddOns;
									// }
									time.AddOnsSkipped = false;
								});
							}
							if (json && json.Times.length == 0) {
								this.noTimesError.show = true;
								this.noTimesError.notes = json.Notes;
							}
							if (json) {
								// console.log("json.Times");
								// console.log(json.Times);
								this.$set(this.activity, 'Times', json.Times);
								this.$set(
									this.activity,
									'TimesClone',
									JSON.parse(JSON.stringify(json.Times))
								);
							}
						},
						abort: () => {
							//this.loadingTimes = false;
						},
					});
				}
			},
		},

		created() {},
	};
</script>

<style scoped>
	.padleft {
		margin-left: 8px;
	}
</style>
